export default __webpack_public_path__ + "static/media/exit.99ed7f2b.svg";